<mat-card *ngIf="showToolsPanel" class="customer-card branding--section-card">
	<mat-card-content>
		<form [formGroup]="toolsForm">
			<mat-form-field subscriptSizing="dynamic">
				<mat-icon matPrefix>search</mat-icon>
				<input matInput formControlName="searchControl" placeholder="{{ 'CUSTOMER_LIST.TOOLS_SEARCH_CONTROL_LABEL' | translate }}" (keydown.escape)="resetFilter()" (keydown.enter)="$event.preventDefault()">
				<button matSuffix mat-icon-button (click)="resetFilter()">
					<mat-icon>clear</mat-icon>
				</button>
			</mat-form-field>
		</form>
	</mat-card-content>
</mat-card>

<mat-expansion-panel *ngFor='let customer of filteredCustomers; let idx = index'
					 class='customer-card list-item-card'
					 [expanded]="forceExpand">
	<mat-expansion-panel-header>
		<div class="card-header">
			<app-advertiser-id-chip [customer]="customer" />
		</div>
	</mat-expansion-panel-header>
	<div class='card-content-container'>
		<div class="fields-container-group">
			<div class='fields-container'>
				<div class='field'>
					<div class='data-panel-field-label'>{{ "CUSTOMER_LIST.FIELD_LABELS.ADDRESS" | translate }}</div>
					<div class='data-panel-field-value'>{{ customer.address }}</div>
					<div class='data-panel-field-value'>
						{{ customer.zipCode }} {{ customer.city }}
						<span *ngIf="customer.province">({{ customer.province }})</span>
					</div>
					<div class='data-panel-field-value'>{{ customer.country }}</div>
				</div>
				<div class='field'>
					<div class='data-panel-field-label'>{{ "CUSTOMER_LIST.FIELD_LABELS.ORGANISATION_NUMBER" | translate }}</div>
					<div class='data-panel-field-value'>{{ customer.organisationNumber }}</div>
				</div>
			</div>
			<div class='fields-container' *ngIf="getDefaultContact(customer) as defaultContact">
				<div class='field'>
					<div class='data-panel-field-label'>{{ "CUSTOMER_LIST.FIELD_LABELS.CONTACT" | translate }}</div>
					<div class='data-panel-field-value'>{{ defaultContact.firstName }}&nbsp;{{ defaultContact.lastName }}</div>
				</div>
				<div class='field'>
					<div class='data-panel-field-label'>{{ "CUSTOMER_LIST.FIELD_LABELS.EMAIL" | translate }}</div>
					<div class='data-panel-field-value'>{{ defaultContact.email }}</div>
				</div>
				<div class='field'>
					<div class='data-panel-field-label'>{{ "CUSTOMER_LIST.FIELD_LABELS.PHONE" | translate }}</div>
					<div class='data-panel-field-value'>{{ defaultContact.phone }}</div>
				</div>
			</div>
		</div>
	</div>
	<mat-action-row>
		<button *ngIf="!choose && !customer.agency" mat-stroked-button (click)='showCustomer(customer)'>
			{{ "CUSTOMER_LIST.ACTION_BUTTON_LABELS.VIEW" | translate }}
		</button>
		<button *ngIf="!choose" mat-stroked-button (click)="showOrders(customer)">
			{{ "CUSTOMER_LIST.ACTION_BUTTON_LABELS.VIEW_ORDERS" | translate }}
		</button>
		<button *ngIf="!choose" mat-stroked-button (click)='createOrder(customer)'>
			{{ "CUSTOMER_LIST.ACTION_BUTTON_LABELS.NEW_ORDER" | translate }}
		</button>
		<button *ngIf="choose && chooseAgency" mat-raised-button color="primary" (click)='createOrder(customer)'>
			{{ "ACTION_BUTTON_LABELS.NEXT" | translate }}
		</button>
		<button *ngIf="choose && !chooseAgency" mat-raised-button color="primary" (click)='createOrder(customer)'>
			{{ "CUSTOMER_LIST.ACTION_BUTTON_LABELS.NEW_ORDER" | translate }}
		</button>
	</mat-action-row>
</mat-expansion-panel>

<mat-card class="no-items" *ngIf="(customers$ | async)?.length === 0 || isFilteredCustomersListEmpty">
	<mat-card-header>
		<mat-chip-set>
			<mat-basic-chip>{{ (showToolsPanel ? "CUSTOMER_LIST.NO_CUSTOMERS_ALERT" : "CUSTOMER_LIST.NO_RECENT_CUSTOMERS_ALERT") | translate }}</mat-basic-chip>
		</mat-chip-set>
	</mat-card-header>
</mat-card>


<ng-container *ngIf="(customers$ | async) === undefined">
	<cass-indeterminate-circular-progress-indicator></cass-indeterminate-circular-progress-indicator>
</ng-container>
